import type * as T from 'three';

// true when WebGL runs without a graphics chip (software drawing, as on some old or locked-down devices and in
// test browsers): those get the same scene without shadows, so the game stays smooth
export function softwareRenderer(renderer: T.WebGLRenderer) {
  try {
    const gl = renderer.getContext();
    const info = gl.getExtension('WEBGL_debug_renderer_info');
    const name = String(info ? gl.getParameter(info.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER));
    return /swiftshader|llvmpipe|software|softpipe|basic render/i.test(name);
  } catch {
    return false;
  }
}
